/* ==========================================================================
   runs when everything is loaded
   ========================================================================== */
var lifeCount = 3;
var activeIndex = 0;
var totalQuestions = 0;

$(window).load(function () {
    var questions = $(".question-slide");

    questions.each(function (i) {
        $("h6[data-quiz='QuizNumber']", $(this)).html("Question " + (i + 1) + " of " + questions.length);
        totalQuestions++;
    });

    jumpToSlide();

    $(".btn-next").on("click", function (e) {
        e.preventDefault();
        activeIndex++;
        if (lifeCount == 0) {
            $(".question-slide").addClass("hide");
            $(".quiz-danger").removeClass("hide");
        }
        else {
            if (activeIndex == totalQuestions) {
                $(".question-slide").addClass("hide");
                $(".quiz-success").removeClass("hide");
            } else {
                jumpToSlide();
            }
        }
    });

    $(".btn-play-again").on("click", function (e) {
        e.preventDefault();
        resetQuiz();
    });
});

$(window).resize(function () {
    if ($(this).width() != width) {
        vCenterQuiz('.quiz-slide:not(.hide)');
    }
});

function jumpToSlide() {
    $(".question-slide").addClass("hide").eq(activeIndex).removeClass("hide");

    vCenterQuiz('.quiz-slide:not(.hide)');
}

function resetQuiz() {
    lifeCount = 3;
    activeIndex = 0;
    $(".quiz-slide")
        .addClass("hide")
        .removeClass("answered-wrong")
        .removeClass("answered-correctly");
    $("#lives").removeAttr("style");
    jumpToSlide();
}

function vCenterQuiz(singleSlide) {
    if ($(window).width() >= 992) {
        $(singleSlide).each(function () {
            var nativeHeight = 0;
            var shiftDown = 0;
            var currentItem = $(this);
            var quizHeight = $(currentItem).closest(".quiz-box").height();
            // console.log($(this).text());
            $(currentItem).css({
                'padding-top': 0,
                'padding-bottom': 0,
            });
            nativeHeight = $(currentItem).outerHeight();
            // console.log('nativeHeight: ' + nativeHeight);
            // console.log('quizHeight: ' + quizHeight);
            shiftDown = (quizHeight - nativeHeight) / 2;
            $(currentItem).css({
                'padding-top': shiftDown + 'px',
            });
        })
    } else {
        $(singleSlide).each(function () {
            $(this).attr('style', '');
        });
    }
}

$('.answer').on('click', function (event) {
    event.preventDefault();
    var clickedItem = $(this);
    var questionSlide = $(clickedItem).closest(".question-slide");

    if (!$(clickedItem).hasClass('stopClick')) {
        if ($(clickedItem).hasClass('correct')) {
            $(questionSlide).removeClass('answered-wrong');
            $(questionSlide).addClass('answered-correctly');
        } else {
            $(questionSlide).removeClass('answered-correctly');
            $(questionSlide).addClass('answered-wrong');
            lifeCount--;

            // life check
            if (lifeCount >= 0) {
                switch (lifeCount) {
                    case 3:
                        $('#lives').css({ 'background-position': 'right top 0px' });
                        break;
                    case 2:
                        $('#lives').css({ 'background-position': 'right top -30px' });
                        break;
                    case 1:
                        $('#lives').css({ 'background-position': 'right top -60px' });
                        break;
                    case 0:
                        $('#lives').css({ 'background-position': 'right top -90px' });
                        break;
                    default:
                        $('#lives').css({ 'background-position': 'right top -90px' });
                        break;
                }
            } else {
                $(".quiz-danger").removeClass("hide");
            }
        }
    }
    // stop duplicate click from changing answer
    $(questionSlide).find('.correct').addClass('stopClick');
});